import { footerLinks, socialAccounts } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="border-t border-primary-800 bg-primary-900 text-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-800">
                <i className="ri-newspaper-line text-xl"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold tracking-wide">黑料官方</span>
                <span className="mt-1 text-[10px] tracking-[0.32em] text-primary-200">
                  全平台社交矩阵
                </span>
              </span>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-primary-100">
              这里聚合黑料官方微博、公众号、推特及电报等全平台账号信息，方便你第一时间锁定
              <strong className="font-semibold text-background-50">黑料官方</strong>
              社交矩阵，随时跟进各渠道发布的动态与内容，不再错过任何一条来自黑料官方的消息。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold tracking-widest text-background-50">
              <a href="#top" className="transition-colors hover:text-accent-300">
                页面导航
              </a>
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="whitespace-nowrap text-sm text-primary-100 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold tracking-widest text-background-50">
              <a href="#matrix" className="transition-colors hover:text-accent-300">
                官方账号
              </a>
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {socialAccounts.map((account) => (
                <li key={account.id}>
                  <a
                    href="#matrix"
                    className="flex items-center gap-3 whitespace-nowrap text-sm text-primary-100 transition-colors hover:text-background-50"
                  >
                    <i className={`${account.icon} text-base`}></i>
                    {account.name}
                    <span className="text-xs text-primary-300">{account.handle}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 黑料官方 · 本页仅聚合公开社交账号信息</span>
          <span className="flex items-center gap-2">
            <i className="ri-shield-check-line text-base"></i>
            请以本页列出的账号 ID 为准，谨防仿冒
          </span>
        </div>
      </div>
    </footer>
  );
}